import { api } from './client'
import type { ApiEnvelope } from '@/types/api'

const PERMISSION_BASE = '/v1/permission-management'

export interface PermissionListItem {
    id: string
    code: string
    name: string
    categoryId?: string
    isSelected?: boolean
}

export interface PermissionCategoryPermissionList {
    id: string
    name: string
    permissionList: PermissionListItem[]
    isSelected?: boolean
}

export interface PermissionGroupDetail {
    id: string
    code?: string
    name?: string
    description?: string
    status?: number
    categoryPermissionList: PermissionCategoryPermissionList[]
}
export interface PermissionGroupListItem {
    id: string
    code: string
    name: string
}

export async function getPermissionGroupById(
    id: string,
    signal?: AbortSignal,
): Promise<PermissionGroupDetail> {
    try {
        const response = await api.get<ApiEnvelope<PermissionGroupDetail>>(
            `${PERMISSION_BASE}/group/${id}`,
            { signal },
        )

        return response.data.responseData
    } catch (error: any) {
        const message = error?.response?.data?.responseMessage || error?.message || 'Đã xảy ra lỗi khi lấy chi tiết nhóm quyền.';
        throw new Error(message);
    }
}


/**
 * List permission groups.
 */
export async function fetchPermissionGroups(
    params?: Record<string, any>,
    signal?: AbortSignal,
): Promise<PermissionGroupListItem[]> {
    type SpringPageLike = { content?: PermissionGroupListItem[] }
    try {
        const response = await api.get<ApiEnvelope<SpringPageLike | PermissionGroupListItem[]>>(
            `${PERMISSION_BASE}/group`,
            { params, signal },
        )

        const data = response.data.responseData
        if (Array.isArray(data)) return data
        return Array.isArray((data as any).content) ? (data as any).content : []
    } catch (error: any) {
        const message = error?.response?.data?.responseMessage || error?.message || 'Đã xảy ra lỗi khi lấy danh sách nhóm quyền.';
        throw new Error(message);
    }
}




